import React from 'react';

import { CheckIcon, DataTable, type TableColumn } from '@/src/ui';
import { ReportHeaderStyle, ReportCellStyle } from '@/src/utils';
import type { SubmissionReportRowDTO } from '../models/submissionReportDTOs';

type SubmissionReportTableProps = {
    rows: SubmissionReportRowDTO[];
};

const SubmissionReportTable: React.FC<SubmissionReportTableProps> = ({ rows }) => {
    const columns: TableColumn[] = [
        {
            dataKey: 'studentName',
            header: 'Student',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'className',
            header: 'Class',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'examName',
            header: 'Assessment',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (row: SubmissionReportRowDTO) => {
                return (
                    <a href={`/reports/questionList/${row.examId}`} target="_blank">
                        {row.examName}
                    </a>
                );
            },
        },
        {
            dataKey: 'status',
            header: 'Status',
            align: 'left',
            allowSort: true,
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: SubmissionReportRowDTO) => {
                if (!r.status)
                    return <CheckIcon color="green" style={{ width: '24px', height: '24px' }} />;
                else return r.status;
            },
        },
        {
            dataKey: 'score',
            header: 'Score',
            align: 'left',
            allowSort: true,
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: SubmissionReportRowDTO) =>
                r.score != null ? `${Math.max(r.score, 0)}%` : '-',
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={rows}
            tableName="Submission Report"
            rowsPerPageInitial={50}
            enableExportCSV
            enableExportExcel
            alternatingRowColor
        />
    );
};

export default SubmissionReportTable;
